import {Injectable } from '@angular/core';
import {Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { Conversation,
    ConversationContextWrapper,
    ConversationThread,
    Message,
    ConversationContacts, 
    ConversationContact,
    ThreadMessage} from 'app/clmtlk/shared/model/conversationContacts';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { BlockUIService } from 'ng-block-ui';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { Observable } from 'rxjs/Observable';
import { HelperService } from 'app/common/service/model-helper.service';
import { newConversationThreads, newThreadMessage, newConversation } from 'app/clmtlk/shared/model/new-model-instance';


@Injectable()
export class NewMessageResolver implements Resolve<Conversation> {

    constructor(private clmtlkService: ClmtlkService,
        private router: Router,
        private blockUIService: BlockUIService,
        private clmtlkSessionService: ClmtlkSessionService,
        private helperService: HelperService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Conversation | Observable<Conversation> | Promise<Conversation>{

        let returnConversation: Conversation;
        const actionParam = route.paramMap.get('action');
        const loggedInConversationContact = this.helperService.cloneDeep(this.clmtlkSessionService.loggedInContact);

        if (!loggedInConversationContact ||
            !this.clmtlkSessionService.getConversationContext() ||
            this.clmtlkSessionService.getConversationContext() == null) {
                console.warn('Logged Contact session doesnt exist, redirect to inbox view to fetch data');
                this.router.navigate(['/inbox']);
                return;
        }



        if (this.clmtlkSessionService.getConversationContext() &&
            this.clmtlkSessionService.getConversationContext() !== null ) {
            const conversationContext: ConversationContextWrapper = this.clmtlkSessionService.getConversationContext();

            if (conversationContext.conversationType === 'NEW_STREAM_CONVERSATION') {
               returnConversation = this.createNewConversationForStream(conversationContext, loggedInConversationContact);
            }else if (conversationContext.conversationType === 'NEW_CUSTOMER_CONVERSATION') {
               returnConversation = this.createNewConversationForCustomer(conversationContext, loggedInConversationContact);
            } else if (conversationContext.conversationType === 'EXISTING_THREAD_CONVERSATION') {
               returnConversation = this.createNewConversationForExistingThread(conversationContext,
                                            loggedInConversationContact, actionParam);
            }
        }

        return returnConversation;
    }

    // If Reply/Replyall is clicked, then get the Conversation from session and pass the same.
    // Copy contacts from previous latest(by message id) message and swap from and to, copy message subject
    // Based on reply  or replyall add to contact address
    createNewConversationForExistingThread(conversationContext: ConversationContextWrapper, 
        loggedInConversationContact: ConversationContact,
        actionParam: string): Conversation {

        let conversation: Conversation;
        conversation = this.helperService.cloneDeep(conversationContext.conversation);

        // find a latest message
        let latestMessage: Message;
        const threadMessageList: ThreadMessage[] = conversation
                                     .conversationThreads.conversationThread[0]
                                     .threads.thread[0]
                                     .threadMessages.threadMessage;

        threadMessageList.forEach(threadMessage => {
            const message: Message = threadMessage.messages.message[0];
            if (!latestMessage || message.MSG_ID > latestMessage.MSG_ID) {
                latestMessage = message;
            }
        });

        const conversationContactList: ConversationContact[] = [];
        latestMessage.conversationContacts.conversationContact.forEach(conversationContact => {
            conversationContact.CONV_CTC_ID = null;
            // Ignore the ConversationContact if same as LoggedinContact, since loggedincontact is already added as 'frm' contact
            // tslint:disable-next-line:triple-equals
            if (conversationContact.contacts.contact[0].CTC_ID ==
                loggedInConversationContact.contacts.contact[0].CTC_ID) {
                    // skip

            // Change from to To
            }else if (conversationContact.CTC_ADDR_TYP_CD.toLowerCase() === 'frm') {
                conversationContact.CTC_ADDR_TYP_CD = 'to';
                conversationContactList.push(conversationContact);

            // If REPLY ALL action, then add all the other contacts
            }else if (actionParam === 'replyall' && conversationContact.CTC_STS_CD.toUpperCase() === 'V') {
                conversationContactList.push(conversationContact);
            }
        });

        conversationContactList.push(loggedInConversationContact);
        this.resetConversationContacts(conversationContactList);
        conversation.newConversationContacts = { conversationContact: conversationContactList };
        conversation.conversationThreads.conversationThread[0].THRD_ID = null;
        conversation.conversationThreads.conversationThread[0].threads.thread[0].THRD_ID = null;
        threadMessageList.forEach(threadMessage => {
            threadMessage.messages = null;
        });
        threadMessageList.push(newThreadMessage());

        return conversation;
    }

    // If Customer initiate a new Conversation.
    createNewConversationForCustomer(conversationContext: ConversationContextWrapper,
        loggedInConversationContact: ConversationContact): Conversation {

        const conversation: Conversation = newConversation();
        const conversationContactList: ConversationContact[] = [loggedInConversationContact];
        this.resetConversationContacts(conversationContactList);
        conversation.newConversationContacts = { conversationContact: conversationContactList };
        return conversation;
    }

    // Check ClmtlkSessionService, if its a new Conversation for Stream.
    // Then pass the conversation object from the session.
    createNewConversationForStream(conversationContext: ConversationContextWrapper,
        loggedInConversationContact: ConversationContact): Conversation {

        let conversation: Conversation;
        const orginalConversation: Conversation = conversationContext.conversation;
        conversation = this.helperService.cloneDeep(conversationContext.conversation);
        // Reset new Conversation Contacts for Stream user, when new message is created.
        if (loggedInConversationContact.CTC_SRC_CD.toLowerCase() === 'st') {
            conversation.newConversationContacts.conversationContact = [loggedInConversationContact];
        }

        conversation.conversationThreads = newConversationThreads();
        return conversation;
    }


    resetConversationContacts(conversationContacts: ConversationContact[]): ConversationContact[] {
        if (!conversationContacts || conversationContacts.length === 0) {
            return conversationContacts;
        }

        conversationContacts.forEach(conversationContact => {
            conversationContact.CONV_CTC_ID = null;
            conversationContact.OAUTH_TOKEN = null;
            conversationContact.MSG_READ_IND = null;
            conversationContact.THRD_ID = null;
            conversationContact.MSG_ID = null;
        });
        return conversationContacts;
    }




}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/new-message/shared/new-message-resolver.service.ts